<div class="edit-container">
    <form class="add-card__form d-flex flex-column" [formGroup]="form" (submit)="updateFunctieOperator()">
        <h1 class="edit-title">Actualizare funcție Operator</h1>
        <div class="row flex-grow-1">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Funcție</mat-label>
                    <mat-select formControlName="functie_id">
                        <mat-option *ngFor="let row of functiiOperator$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="p-2">
                <mat-divider></mat-divider>
            </div>
        </div>
        <div class="row mt-auto">
            <div class="col d-flex justify-content-between">
                <button class="btn btn-light" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="btn btn-primary" type="submit" mat-flat-button color="primary" [disabled]="isLoading">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>

        <div class="section-spinner position-absolute" *ngIf="isLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
            </div>
        </div>
    </form>
</div>